module.exports = __webpack_public_path__ + "img/c01_unitstartechfireshipchampion_Normal_ua.ef033f34.webp";